import React, { useState, useEffect } from "react";
import { Range } from "react-range";
import * as S from "./index.styles";

interface IPriceFilter {
  onChangeComplete: Function;
  min: number;
  max: number;
}

export const PriceFilter: React.FC<IPriceFilter> = ({
  onChangeComplete = () => {},
  min = 0,
  max = 200,
}) => {
  const [range, setRangeValue] = useState({ min, max });

  useEffect(() => {
    setRangeValue({ min, max });
  }, [min, max]);

  return (
    <S.PriceFilter>
      <Range 
        step={25}
        min={min}
        max={max}
        values={[range.min, range.max]}
        onChange={(value) => setRangeValue({ min: value[0], max: value[1] })}
        onFinalChange={(value) => onChangeComplete({ min: value[0], max: value[1] })}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '1rem',
              width: '100%',
              backgroundColor: '#2276e3',
              marginBottom: '1rem'
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '1.8rem',
              width: '1.8rem',
              borderRadius: '50%',
              border: '0.2rem solid #2276e3',
              backgroundColor: '#fff'
            }}
          />
        )}
      />
      <span className="fl">
        <i className="icon-rupee fl ico12 padT3"></i> {range.min}
      </span>
      <span className="fr">
        <i className="icon-rupee fl ico12 padT3"></i> {range.max}
      </span>
    </S.PriceFilter>
  );
};

export default React.memo(PriceFilter);
